/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable prefer-template */
/* eslint-disable no-lonely-if */
import React, {useState, useMemo, useEffect} from 'react';
import DOMPurify from 'dompurify';
import {Menu, Popover, Input} from '@enos/dpl';
import localeText from '@locale';
import {LAN_EN_KEY, LAN_ZH_KEY} from '~/utils/constant';
import zhContext from '~/locale/zh-CN.js';
import Logo from '~/assets/images/top_logo_global.png';
import './index.less';

const {SubMenu} = Menu;
const {Search} = Input;

const Header = ({locale, version, menuOpen, setMenuOpen, isTutorial, configData, versionKeys, insertTheme = false, history}) => {
  const langList = [
    {
      label: 'English',
      key: LAN_EN_KEY
    },
    {
      label: zhContext.COMMON.CHINESE,
      key: LAN_ZH_KEY
    }
  ];
  const [openKeys, setOpenKeys] = useState([]);
  const [switchLeftValue, setSwitchLeftValue] = useState('version');
  const [openSearchInput, setOpenSearchInput] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [popoverOpen, setPopoverOpen] = useState(false);

  const mobileUrlObject = useMemo(() => configData.reduce((pre, nex, index) => {
    pre[`sub${index + 1}`] = {
      showList: nex?.showListInMobile,
      url: nex?.footer?.url
    };
    return pre;
  }, {}), [configData]);

  const onOpenChange = (keys) => {
    if (keys[keys.length - 1] && !mobileUrlObject[keys[keys.length - 1]]?.showList) {
      window.open(mobileUrlObject[keys[keys.length - 1]]?.url);
      return null;
    }
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (Object.keys(mobileUrlObject).indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  const formatterList = useMemo(() => configData.map((d) => ({
    category: d.category,
    // mobileUrl: d.mobileUrl,
    showList: d.showListInMobile,
    list: d?.item?.map((item) => item?.list?.map((list) => ({name: list?.name, url: list?.url}))).flat()
  })), [configData]);

  const switchRightContent = useMemo(() => {
    if (switchLeftValue === 'version') {
      return versionKeys.map((item) => (
        <div
          className={item === version ? 'active' : ''}
          onClick={() => {
            if (insertTheme) {
              const url = window.location.href.replace(/\/(zh_CN|en)\/((\d+.\d+.\d+)|dev|stable|preview|master|latest)\//, `/${locale}/${item}/`);
              window.location.href = DOMPurify.sanitize(url);
            } else {
              history.push(`/${locale}/${item}${isTutorial ? '/tutorial' : ''}`);
            }
            setPopoverOpen(false);
          }}
        >
          {item}
        </div>
      ));
    }
    return langList.map((item) => (
      <div
        className={item.key === locale ? 'active' : ''}
        onClick={() => {
          if (insertTheme) {
            const url = window.location.href.replace(/\/(zh_CN|en)\/((\d+.\d+.\d+)|dev|stable|preview|master|latest)\//, `/${item.key}/${version}/`);
            window.location.href = DOMPurify.sanitize(url);
          } else {
            history.push(`/${item.key}/${version}${isTutorial ? '/tutorial' : ''}`);
          }
          setPopoverOpen(false);
        }}
      >
        {item.label}
      </div>
    ));
  }, [switchLeftValue, versionKeys, langList, version, locale, insertTheme, isTutorial]);

  useEffect(() => {
    const root = document.querySelector('#root');
    if (root) {
      if (menuOpen) {
        root.style.height = '100vh';
        root.style.width = '100vw';
        root.style.overflow = 'hidden';
      } else {
        root.style.height = 'unset';
        root.style.width = 'unset';
        root.style.overflow = 'unset';
      }
    }
    const listenerScroll = () => {
      const scrollPosition = window.scrollY;
      const header = document.querySelector('#root .new-mobile-header');
      if (header) {
        if (menuOpen) {
          header.style.backgroundColor = '#111111';
        } else {
          if (scrollPosition > 0) {
            header.style.backgroundColor = '#111111';
          } else {
            header.style.backgroundColor = 'transparent';
          }
        }
      }
    };
    listenerScroll();
    window.addEventListener('scroll', listenerScroll);
    return () => {
      window.removeEventListener('scroll', listenerScroll);
    };
  }, [menuOpen]);

  return (
    <>
      <div className={`new-mobile-header ${insertTheme ? 'theme' : ''}`}>
        {openSearchInput ? (
          <div className='global-search-header'>
            <Search
              className='global-search'
              placeholder={localeText('COMMON.SEARCH_DOCUMENT')}
              allowClear
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onPressEnter={() => { window.location.href = DOMPurify.sanitize(`/docs/${locale}/globalSearch?q=${searchValue}`); }}
            />
            <div className='close-search' onClick={() => setOpenSearchInput(false)}><i className='dpl20_wrong close' /></div>
          </div>
        ) : (
          <>
            <div className='header-menu-wrap' onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? (
                <i className='dpl20_wrong menu' />
              ) : (
                <i className='dpl20_menu menu' />
              )}
            </div>
            <div className='header-logo-wrap'>
              <img className='logo' src={Logo} alt='logo' />
            </div>
            <div className='search-switch-wrap' style={{display: menuOpen ? 'none' : 'flex'}}>
              <div className='search-wrap' onClick={() => setOpenSearchInput(true)}><i className='dpl20_search search' /></div>
              <Popover
                trigger='click'
                placement='bottom'
                color='#292830'
                overlayClassName='mobile-header-popover-wrapper'
                open={popoverOpen}
                onOpenChange={(open) => {
                  setPopoverOpen(open);
                  if (open) {
                    setSwitchLeftValue('version');
                  }
                }}
                content={(
                  <div
                    className='mobile-header-popover'
                    style={{
                      minHeight: Math.max(versionKeys.length, langList.length) * 36 + (Math.max(versionKeys.length, langList.length) - 1) * 4 + 24
                    }}
                  >
                    <div className='switch-left'>
                      <div className={`version ${switchLeftValue === 'version' ? 'active' : ''}`} onClick={() => setSwitchLeftValue('version')}>
                        {localeText('COMMON.TXT_VERSION')}
                      </div>
                      <div className={`lang ${switchLeftValue === 'lang' ? 'active' : ''}`} onClick={() => setSwitchLeftValue('lang')}>
                        {localeText('COMMON.TXT_LANG')}
                      </div>
                    </div>
                    <div className='switch-right'>{switchRightContent}</div>
                  </div>
                )}
              >
                <div className='switch-wrap'><i className='dpl20_setting setting' /></div>
              </Popover>
            </div>
          </>
        )}
      </div>
      {menuOpen ? (
        <div className='new-mobile-header-menu-list'>
          <Menu
            mode='inline'
            openKeys={openKeys}
            onOpenChange={onOpenChange}
          >
            {formatterList.map((item, index) => (
              <SubMenu
                key={`sub${index + 1}`}
                title={item?.category}
                className={!item?.showList ? 'no-list' : ''}
                // eslint-disable-next-line no-nested-ternary
                expandIcon={!item?.showList ? <i className='dpl20_right' /> : (openKeys.includes(`sub${index + 1}`) ? <i className='dpl20_up' /> : <i className='dpl20_down' />)}
              >
                {item?.showList ? item?.list?.map((l, ind) => (
                  <Menu.Item
                    key={'sub' + index + '_' + ind}
                    onClick={() => window.open(l.url)}
                  >
                    {l.name}
                  </Menu.Item>
                )) : null}
              </SubMenu>
            ))}
          </Menu>
        </div>
      ) : null}
    </>
  );
};

export default Header;
